<template>
  <b-sidebar
      id="table-sidebar"
      :visible="isTableSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      :backdrop="false"
      no-header
      width="55em"
      @change="(val) => $emit('update:is-table-sidebar-active', val)">

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ title }}</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide"/>
      </div>

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner :animation-duration="1000" :size="50" :color="'#0e96b1'"/>
      </div>

      <!-- BODY -->
    
      <slot name="filter"></slot>


<!--        <div class="div-colors">-->
<!--          <b-row>-->
<!--            <b-col cols="6">-->
<!--              <ul>-->
<!--                <li> <span  class=" dot d-offline"><p class="dot-txt">{{$t("offLine")}}</p></span> </li>-->
<!--                <li> <span  class=" dot d-moving"><p class="dot-txt">{{$t("moving")}} </p></span> </li>-->
<!--                <li> <span  class=" dot d-stop"><p class="dot-txt">{{$t("stop")}}</p></span> </li>-->
<!--                <li> <span  class=" dot d-overspeed"><p class="dot-txt">{{$t("OverSpeed")}}</p></span></li>-->

<!--              </ul>-->
<!--            </b-col>-->
<!--            <b-col cols="6">-->
<!--              <ul>-->
<!--                <li> <span  class=" dot d-ignitionoff"><p class="dot-txt">{{$t("ignitionOff")}}</p></span> </li>-->
<!--                <li> <span  class=" dot d-pto"><p class="dot-txt">{{$t("pto")}}</p> </span></li>-->
<!--                <li> <span  class=" dot d-sweep"><p class="dot-txt">{{$t("sweep")}}</p></span> </li>-->
<!--                <li> <span  class=" dot d-unknown"><p class="dot-txt">{{$t("unknown")}}</p></span> </li>-->

<!--              </ul>-->
<!--            </b-col>-->

<!--          </b-row>-->

<!--         </div>-->

      <slot name="getRoute"></slot>

      <slot name="colors-map"></slot>

      <div class="m-2">
        <!-- Table Top -->
        <b-row class="mb-2">
          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select
                v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                :clearable="false" class="per-page-selector d-inline-block mx-50"/>
            <label>{{ $t('entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input  v-debounce:500ms="debounceSearch" class="d-inline-block mr-1" :placeholder="$t('Search...')"/>
            </div>
          </b-col>
        </b-row>

        <b-table small ref="refListTable" class="table-responsive"
                 selectable select-mode="single" @row-selected="rowSelected"
                 :items="data" responsive
                 :fields="tableColumns" primary-key="id"
                 show-empty :empty-text="$t('No matching records found')">

          <!-- Column: name -->
          <template #cell(id)="data">
            {{ ++data.index }}
          </template>

          <!-- Column: name -->
          <template #cell(name)="data">
            <span v-bind:style="[data.item.id === selectedItem ? {'color': '#e77171'} : '']"> {{ data.item.name }}</span>
          </template>

          <template #cell(status)="data">
<!--            <img style="width: 30px" class="rotate-90" :src="require('@/assets/markers/'+data.item.status+'.svg')" alt="">-->
            <img style="width: 20px" class="" :src="getImg(data.item)" alt="">
          </template>

          <template #cell(track)="data">
            <b-form-checkbox name="tracked_devices" v-model="trackedDevices" :value="data.item.id"></b-form-checkbox>
          </template>

          <!-- <template #cell(route)="data">

            <img width="20px" :src="require('@/assets/icons/route.svg')"
                 @click="eventBus.$emit('getRoute', data.item.id,data.item.contract_id)" alt="">
          </template> -->
          <template #cell(actions)="data">
            <b-dropdown class="actionIcon" variant="link" no-caret :right="$store.state.appConfig.isRTL" boundary="viewport">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body"/>
              </template>

<!--              <b-dropdown-item v-if="data.item.category === 'COMPACTOR'"  @click="eventBus.$emit('getPlan', data.item.id, rangeDate)">-->
<!--                {{ $t('RFID Route 2') }}-->
<!--                <span class="align-middle ml-50">-->
<!--                  <img width="20px" :src="require('@/assets/icons/route.svg')" alt="">-->
<!--                </span>-->
<!--              </b-dropdown-item>-->


<!--              <b-dropdown-item v-if="data.item.category === 'COMPACTOR'"-->
<!--                               @click="openTrackCompactorPlanWindow(data.item.id)">-->
<!--                {{ $t('compactor plan track') }}-->
<!--                <span class="align-middle ml-50">-->
<!--                  <img width="20px" :src="require('@/assets/icons/route.svg')" alt="">-->
<!--                </span>-->
<!--              </b-dropdown-item>-->


<!--              <b-dropdown-item v-if="data.item.category === 'COMPACTOR'"  @click="eventBus.$emit('getRfidPlan', data.item.id, rangeDate)">-->
<!--                {{ $t('RFID Route') }}-->
<!--                <span class="align-middle ml-50">-->
<!--                  <img width="20px" :src="require('@/assets/icons/route.svg')" alt="">-->
<!--                </span>-->
<!--              </b-dropdown-item>-->

              <b-dropdown-item  @click="eventBus.$emit('getRoute', data.item.id,data.item.contract_id)">
                {{ $t('Route History') }}
                <span class="align-middle ml-50">
                  <img width="20px" :src="require('@/assets/icons/route.svg')" alt="">
                </span>
              </b-dropdown-item>

              <b-dropdown-item  @click="eventBus.$emit('getRoute2', data.item.id)"> {{ $t('Route History') }}
                <span style="background-color: #1ab7ea; padding: 0 5px 0 5px; color: white">{{$t('new')}}</span>
                <span class="align-middle ml-50">
                  <img width="20px" :src="require('@/assets/icons/route.svg')" alt="">
                </span>
              </b-dropdown-item>


<!--              <b-dropdown-item   @click="eventBus.$emit('getRouteLive', data.item.id,data.item.contract_id)">-->
<!--                {{ $t('Route Live') }}-->
<!--                <span class="align-middle ml-50">-->
<!--              <img width="20px" class="ml-1" :src="require('@/assets/icons/route.svg')"-->
<!--                   alt="">-->
<!--            </span>-->
<!--              </b-dropdown-item>-->

              <b-dropdown-item   @click="eventBus.$emit('getLiveTrk', data.item.id)">
                {{ $t('Live Track') }}
                <span class="align-middle ml-50">
              <img width="20px" class="ml-1" :src="require('@/assets/icons/route.svg')"
                   alt="">
            </span>
              </b-dropdown-item>

              <b-dropdown-item  v-if="data.item.has_cam" @click="eventBus.$emit('getCamLive', data.item.id)">
                {{ $t('Cam Live') }}
                <span class="align-middle ml-50">
              <img width="20px" class="ml-1" :src="require('@/assets/icons/route.svg')"
                   alt="">
            </span>
              </b-dropdown-item>

              <b-dropdown-item   v-if="data.item.has_cam" @click="eventBus.$emit('getCamPlayback', data.item.id)">
                {{ $t('Cam Playback') }}
                <span class="align-middle ml-50">
              <img width="20px" class="ml-1" :src="require('@/assets/icons/route.svg')"
                   alt="">
            </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

        </b-table>

      </div>

      <div class="mx-2 mb-2">
        <b-row>
          <!-- Pagination -->
          <b-col cols="12" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-muted">{{ $t('Showing') }} {{ meta!=undefined? meta.from:'' }} {{ $t('to') }} {{meta!=undefined? meta.to:'' }} {{ $t('of') }} {{meta!=undefined? meta.total:'' }}
                  {{ $t('entries') }}</span>
              </b-col>
            <b-pagination
                v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18"/>
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18"/>
              </template>
            </b-pagination>
          </b-col>

        </b-row>
      </div>

    </template>
  </b-sidebar>
</template>

<script>
import { BDropdown, BDropdownItem, BDropdownForm, BModal,
  BFormDatepicker, BBadge, BFormCheckbox, BDropdownItemButton,
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback,
  BButton, BTable, BPagination, BRow, BCol, BLink
} from 'bootstrap-vue'

import { onUnmounted, ref, onMounted ,watch} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'
import DevicesListFilters from '@/views/modules/device/devices-list/DevicesListFilters'
import { eventBus } from '@/main'

import store from '@/store'
export default {
  components: {
    DevicesListFilters, BBadge,

    BDropdown, BDropdownItem, BDropdownForm, BDropdownItemButton,
    BFormDatepicker, BFormCheckbox,

    BSidebar,
    BForm,
    BTable,
    BFormGroup,BLink,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BPagination,
    vSelect,
    OrbitSpinner,

    flatPickr,
    BRow,
    BCol,

    BModal

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isTableSidebarActive',
    event: 'update:is-table-sidebar-active',
  },
  props: {
    withAction: {
      type: Boolean,
      default: () => false
    },

    tracked_devices: {
      type: Array
    },

    selectedItem: {
      type: Number,
      required: false
    },

    selectedDevice: {
      type: Number|null,
      required: false
    },

    selectedRow: {
      type: Number|null,
      required: false
    },

    data: {
      type: Array,
      required: true
    },

    title: {
      type: String
    },

    isTableSidebarActive: {
      type: Boolean,
      required: true,
    },

    perPageOptions: {
      type: Array, required: true,
    },

    totalRows: {
      type: Number, required: true
    },

    perPageFilter: {
      type: [Number, String], required: true
    },

    searchQueryFilter: {
      type: String, required: true
    },

    currentPageFilter: {
      type: Number, required: true
    },

    tableObject: {
      required: true
    },

    tableColumns: {
      type: Array,
      required: true
    },

    requestStatus: {
      type: Boolean,
      required: true,
      default: () => false
    },
    meta:{
     type:Object
    }

  },

  setup(props, {emit}) {
   
   
    const refListTable = ref(null)
    const perPage = ref(props.perPageFilter)
    const currentPage = ref(props.currentPageFilter)
    const searchQuery = ref(props.searchQueryFilter)
    const trackedDevices = ref(props.tracked_devices)

    const rangeDate = ref('')

    const pickerOptions = {
      dateFormat: 'Y-m-d H:i:S',
      enableTime: true,
      enableSeconds: true,
      mode: 'range',
      time_24hr: true,
      // static: true,
      defaultDate: ["today"],
      inline: true,
      onChange: function(selectedDates, dateStr, instance) {
        console.log(dateStr)
      },
    }


    const openTrackCompactorPlanWindow = id => {
      eventBus.$emit('trackCompactorPlan', id, rangeDate.value)
    }


    watch(perPage, () => emit('update:perPageFilter', perPage.value))
    watch(currentPage, () => emit('update:currentPageFilter', currentPage.value))
    watch(searchQuery, () => emit('update:searchQueryFilter', searchQuery.value))
    watch(trackedDevices, () => emit('update:tracked_devices', trackedDevices.value))

    watch(refListTable, () => emit('update:tableObject', refListTable.value))

    const set_selected_item = (id) => emit('update:selectedItem', id)

    const rowSelected = e => {
     if (e.length > 0) {
       emit('update:selectedDevice', e[0].id)
       emit('update:selectedRow', e[0].id)
     }else {
       emit('update:selectedDevice', null)
       emit('update:selectedRow', null)
     }
    }
    const debounceSearch = (val) => {
      searchQuery.value = val

    }
  ////  save device data  in store

    const getImg = (device) => {
      let img;
      try {
        img = require('@/assets/markers/'+device.category+'/'+device.status+'.svg')
      } catch (e) {
        img = require('@/assets/markers/'+device.status+'.svg')
      }
      return img
    }

  
    return {
      openTrackCompactorPlanWindow,
      pickerOptions,rangeDate,
      perPage, currentPage, refListTable, searchQuery,
      set_selected_item, trackedDevices,
      rowSelected, eventBus,debounceSearch, getImg
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';


.actionIcon > button {
  padding: 0;
}

.table.b-table > tbody > .table-active, [dir] .table.b-table > tbody > .table-active > th, [dir] .table.b-table > tbody > .table-active > td {
  background-color:  $primary !important;
}
.div-colors{
  margin: 3px;
  // display: flex;
  
}
ul{
  list-style: none;
}
.div-colors >span{
  padding: 2px;
  color: white;
  // flex-basis: 70px;
  text-align: center;
  border-radius: 10px;
}


.d-offline {
  background-color:#4b4b4b;
}
.d-moving{
  background-color:#28c76f;
}
.d-overspeed{
  background-color: #29ff9b
}
.d-stop{
  background-color: #f00;
}
.d-ignitionoff{
  background-color:#800080;
}
.d-pto{
  background-color:#669df6 ;
}
.d-unknown{
  background-color:#666600;
}
.d-sweep {
  background-color:#ffa500
}
.d-idle {
  background-color:#8c0303
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: #161d31;
}

::-webkit-scrollbar-track {
  background-color: #283046;
}

.status-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;          /* 🔥 horizontal */
  flex-wrap: wrap;        /* wrap if no space */
  gap: 16px;              /* spacing between items */
}

.status-item {
  display: flex;          /* 🔥 dot + text inline */
  align-items: center;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
}

/* text */
.dot-txt {
  white-space: nowrap;
  font-size: small;
}


</style>
